import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { NbEvaIconsModule } from "@nebular/eva-icons";
import {
  NbThemeModule,
  NbLayoutModule,
  NbInputModule,
  NbCardModule,
  NbButtonModule,
  NbSelectModule,
  NbSpinnerModule,
  NbAlertModule,
  NbIconModule,
  NbMenuModule,
} from "@nebular/theme";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { LoginComponent } from "./pages/login/login.component";
import { RegisterComponent } from "./pages/register/register.component";
import { RequestPasswordComponent } from "./pages/request-password/request-password.component";
import { ResetPasswordComponent } from "./pages/reset-password/reset-password.component";
import { NotFoundComponent } from "./pages/not-found/not-found.component";
import { ErrorComponent } from "./pages/error/error.component";
import { RequestPasswordSentComponent } from "./pages/request-password-sent/request-password-sent.component";
import { ReactiveFormsModule } from "@angular/forms";
import { RequestVerifivationTokenComponent } from "./pages/request-verifivation-token/request-verifivation-token.component";
import { EmailVerifivationComponent } from "./pages/email-verifivation/email-verifivation.component";
import { TwoFactorAuthComponent } from "./pages/two-factor-auth/two-factor-auth.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AuthInterceptorService } from "./dashboard/services/auth.interceptor.service";

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    RegisterComponent,
    RequestPasswordComponent,
    ResetPasswordComponent,
    NotFoundComponent,
    ErrorComponent,
    RequestPasswordSentComponent,
    RequestVerifivationTokenComponent,
    EmailVerifivationComponent,
    TwoFactorAuthComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NbThemeModule.forRoot({ name: "default" }),
    NbLayoutModule,
    NbInputModule,
    NbCardModule,
    NbButtonModule,
    NbSelectModule,
    ReactiveFormsModule,
    NbSpinnerModule,
    HttpClientModule,
    NbAlertModule,
    NbEvaIconsModule,
    NbIconModule,
    NbMenuModule.forRoot(),
    BrowserAnimationsModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
